
import React, { useCallback } from 'react';


import { LogoutButton } from '../../../buttons/LogoutButton';
import { IconLogoComrex } from '../../../icons';


const AccountSettingTopView = ({user, show, isMod, avatarUrl, displayName, isConference, handleLogout }) => {

    const logout = useCallback(() => {
        handleLogout();
    }, []);

    return(
        <div

            className = { 'account-setting-header' }>
            <div
                className = { `account-comrex account-comrex-500 ${(isMod == undefined || !isMod) ? 'account-comrex-no-mod' : ''}` }>
                <a
                    href = { 'https://www.comrex.com/' }
                    target = { '_blank' }>
                    <IconLogoComrex
                        style = {{
                            marginRight: 10,
                            // height: '100%',
                            width: 150
                        }} />
                </a>
                <img
                    src = '../../../../../../images/gagl.png'
                    style = {{ height: 59 }} />
            </div>
            {isMod && <div
                className = { 'account-setting-menu hide-mod-setting' }>

                <div
                    className = { 'account-setting-dropdown' }>
                    <div
                        style = {{ marginRight: 10 }}
                        className = { 'account-display-name' }>Hi, {displayName}
                    </div>
                    <LogoutButton
                        isMod = { isMod }
                        moderator={isMod}
                        avatarUrl = { avatarUrl }
                        isConference={isConference}
                        handleLogout={ () => logout()}
                    />
                </div>
            </div>}
        </div>
    )
};

export { AccountSettingTopView };
